import React, { memo } from 'react';
import Tippy from '@tippyjs/react/headless';

import { ICustomTooltipProps } from './CustomTooltip.types';

const CustomTooltip: React.FC<ICustomTooltipProps> = ({
	children,
	tooltip,
	delay = 0,
	isDisabled = false,
	placement = 'top',
	visible,
	interactive,
}) => (
	<Tippy
		arrow
		delay={delay}
		disabled={isDisabled}
		interactive={interactive}
		placement={placement}
		render={attrs => (
			<div {...attrs}>
				{tooltip}
			</div>
		)}
		visible={visible}
	>
		{children}
	</Tippy>
);

export default memo(CustomTooltip);
